import React, { useState } from 'react';
import { Button, Modal, Form, InputGroup } from 'react-bootstrap';
import { ShieldLock, Lock, ShieldShaded, ShieldCheck } from 'react-bootstrap-icons';

const ChangePassword = () => {
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    return (
        <>
            {/* Password Section UI */}
            <div className="p-3 mb-3 rounded-3 d-flex align-items-center justify-content-between border border-translucent">
                <div className="d-flex align-items-center">
                    <div className="bg-white p-2 rounded-2 shadow-sm me-3">
                        <Lock className="text-primary" size={20} />
                    </div>
                    <div>
                        <h6 className="mb-0 fs-11 fw-bold text-900">Password</h6>
                        <p className="mb-0 fs-11 text-500">Last changed 3 months ago</p>
                    </div>
                </div>
                <Button
                    variant='warning'
                    size="sm"
                    onClick={() => setShowPasswordModal(true)}
                >
                    Change Password
                </Button>
            </div>

            {/* Change Password Modal */}
            <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
                <Modal.Header closeButton className="border-0 pb-0 px-4 pt-4">
                    <Modal.Title className="d-flex align-items-center gap-2 fs-8 fw-bold text-900 ps-1">
                        <div className="bg-primary-subtle p-2 rounded-2 d-flex align-items-center justify-content-center">
                            <ShieldLock className="text-primary" size={20} />
                        </div>
                        Change Password
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4 px-md-5">
                    <p className="text-600 fs-11 mb-4 ps-1">
                        To ensure the security of your account, please use a strong and unique password.
                    </p>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fs-11 fw-bold text-700 mb-1 ps-1 text-uppercase">Current Password</Form.Label>
                            <div className="input-group rounded-2 overflow-hidden border-0" style={{ border: '1px solid #edf2f9 !important' }}>
                                <span className="input-group-text bg-transparent border-0 pe-0 text-500">
                                    <Lock size={14} />
                                </span>
                                <Form.Control
                                    type="password"
                                    className="bg-transparent border-0 py-2 fs-11 shadow-none"
                                    placeholder="Enter current password"
                                />
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="fs-11 fw-bold text-700 mb-1 ps-1 text-uppercase">New Password</Form.Label>
                            <div className="input-group rounded-2 overflow-hidden border-0" style={{ border: '1px solid #edf2f9 !important' }}>
                                <span className="input-group-text bg-transparent border-0 pe-0 text-500">
                                    <ShieldShaded size={14} />
                                </span>
                                <Form.Control
                                    type="password"
                                    className="bg-transparent border-0 py-2 fs-11 shadow-none"
                                    placeholder="Create a strong password"
                                />
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label className="fs-11 fw-bold text-700 mb-1 ps-1 text-uppercase">Confirm Password</Form.Label>
                            <div className="input-group rounded-2 overflow-hidden border-0" style={{ border: '1px solid #edf2f9 !important' }}>
                                <span className="input-group-text bg-transparent border-0 pe-0 text-500">
                                    <ShieldCheck size={14} />
                                </span>
                                <Form.Control
                                    type="password"
                                    className="bg-transparent border-0 py-2 fs-11 shadow-none"
                                    placeholder="Repeat new password"
                                />
                            </div>
                        </Form.Group>
                        <Button variant="primary" className="w-100 py-2 fw-bold fs-10 rounded-2 shadow-sm d-flex align-items-center justify-content-center gap-2" onClick={() => setShowPasswordModal(false)}>
                            Update  Password
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ChangePassword;
